/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const modulesMetaAdDataInputInterestDataSchema = z.object({
	id: z.string(),
})

export type ModulesMetaAdDataInputInterestDataSchema = z.infer<typeof modulesMetaAdDataInputInterestDataSchema>
